import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind-output.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Services from "./Services";
import Contact from "./Contact";
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from "./ThemeContext"; // <-- Add this

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
